export enum IconColor {
  red = "#AB1122",
  grey = "#444"
}

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  height?: string;
  color?: "red" | "grey";
  scale?: number; 
}

export const CloseIcon = ({ width = "20.932px", height = "20.214px", color = "grey", scale = 1, ...props }: ImageProps) => 
  <div {...props}>
    <style>{`
      .icon-line {
        stroke: ${IconColor[color]};
      }
    `}
    </style>
    <svg className="x-icon" width={width} height={height} viewBox="0 0 20.932 20.214" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: `scale(${scale})` }}>
      <g transform="translate(5130.621 5794.621)">
        <line id="Line_52" className="icon-line" y1="15.973" x2="16.69" transform="translate(-5128.5 -5792.5)" fill="none" strokeLinecap="round" strokeWidth="3"/>
        <line id="Line_910" className="icon-line" x1="16.69" y1="15.973" transform="translate(-5128.5 -5792.5)" fill="none" strokeLinecap="round" strokeWidth="3"/>
      </g>
    </svg>
  </div>

export default CloseIcon;